(() => {
  const sidebar = document.getElementById('halo-cart-sidebar');
  if (!sidebar) return;
  document.querySelectorAll('[data-cart-count]').forEach((counter) => {
    const label = counter.parentElement.querySelector('.visually-hidden');
    if (!label) return;
    const updateLabel = () => {
      const count = Number(counter.textContent.trim());
      if (!Number.isFinite(count)) return;
      const pattern = count === 1 ? sidebar.dataset.singleItem : sidebar.dataset.itemCount;
      if (pattern) label.textContent = pattern.replace('[count]', count);
    };
    new MutationObserver(updateLabel).observe(counter, { childList: true, characterData: true, subtree: true });
    updateLabel();
  });
  let version = 0, saving = false, checkout = false, timer;
  const inputs = () => [...sidebar.querySelectorAll('[data-cart-quantity]')];
  const root = window.Shopify?.routes?.root || '/';
  const errorBox = sidebar.querySelector('[data-pm-cart-error]');
  const valid = () => {
    const bad = inputs().find(input => input.value.trim() === '' || !input.checkValidity());
    if (bad) { bad.reportValidity(); return false; }
    return true;
  };
  async function request(quantity, id) {
    const response = await fetch(`${root}cart/change.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id,quantity})});
    const data = await response.json();
    if (!response.ok || data.status) {
      const error = new Error(data.description || sidebar.dataset.error);
      error.inventory = response.status === 422;
      throw error;
    }
    return data;
  }
  async function render(cart, revision) {
    const response = await fetch(`${root}cart?view=ajax_side_cart`);
    if (!response.ok) throw new Error(sidebar.dataset.error);
    const markup = await response.text();
    if (revision !== version) return false;
    const active = sidebar.contains(document.activeElement) ? document.activeElement : null;
    const activeId = active?.id;
    const values = [...sidebar.querySelectorAll('input:not([data-cart-quantity]),textarea')].map(e=>({id:e.id,value:e.value,checked:e.checked}));
    sidebar.querySelector('.previewCart-wrapper').innerHTML = markup;
    for (const value of values) {
      if (!value.id) continue;
      const input = sidebar.querySelector(`[id="${CSS.escape(value.id)}"]`);
      if (input) { input.value=value.value; input.checked=value.checked; }
    }
    document.querySelectorAll('[data-cart-count]').forEach(e => {
      e.textContent = cart.item_count;
      const label = e.parentElement.querySelector('.visually-hidden');
      if (label) label.textContent=(cart.item_count===1?sidebar.dataset.singleItem:sidebar.dataset.itemCount).replace('[count]',cart.item_count);
    });
    sidebar.querySelectorAll('[data-cart-text]').forEach(e=>e.textContent=cart.item_count===1?sidebar.dataset.one:sidebar.dataset.many);
    sidebar.querySelector('[data-pm-cart-status]').textContent=sidebar.dataset.updated;
    if (activeId) sidebar.querySelector(`[id="${CSS.escape(activeId)}"]`)?.focus({preventScroll:true});
    document.dispatchEvent(new CustomEvent('cart-update',{detail:cart}));
    return true;
  }
  async function save(toCheckout=false) {
    clearTimeout(timer);
    if (toCheckout) checkout=true;
    if (!valid()) { checkout=false; return; }
    if (saving) return;
    saving=true;
    sidebar.setAttribute('aria-busy','true');
    errorBox.hidden=true;
    try {
      let revision,cart;
      do {
        revision=version;
        const changes=inputs().filter(e=>Number(e.value)!==Number(e.defaultValue)).map(e=>({id:e.dataset.line,quantity:Number(e.value)}));
        for (const change of changes) {
          cart=await request(change.quantity,change.id);
          inputs().forEach(e=>e.defaultValue=String(cart.items.find(i=>i.key===e.dataset.line)?.quantity||0));
        }
        if (!valid()) { checkout=false; return; }
        if (revision!==version) continue;
        if (checkout) {
          const terms=sidebar.querySelector('#sidebar_cart_conditions');
          if (terms && !terms.checked) { checkout=false; return; }
          window.location.assign(`${root}checkout`);
          return;
        }
        if (!cart) {
          const response=await fetch(`${root}cart.js`,{headers:{'Accept':'application/json'}});
          if (!response.ok) throw new Error(sidebar.dataset.error);
          cart=await response.json();
        }
        if (await render(cart,revision)) break;
      } while (true);
    } catch (error) {
      checkout=false;
      if (error.inventory) {
        try {
          const response=await fetch(`${root}cart.js`,{headers:{'Accept':'application/json'}});
          if(response.ok) await render(await response.json(),version);
        } catch (_) {}
      }
      errorBox.textContent=error.message||sidebar.dataset.error;
      errorBox.hidden=false;
    } finally {
      saving=false;
      sidebar.removeAttribute('aria-busy');
    }
  }
  function queue(input) {
    version++;
    clearTimeout(timer);
    timer=setTimeout(()=>save(),350);
  }
  document.addEventListener('input',event=>{
    if (!sidebar.contains(event.target) || !event.target.matches('[data-cart-quantity]')) return;
    event.stopImmediatePropagation();
    queue(event.target);
  },true);
  document.addEventListener('change',event=>{
    if (!sidebar.contains(event.target) || !event.target.matches('[data-cart-quantity]')) return;
    event.stopImmediatePropagation();
    save();
  },true);
  document.addEventListener('click',event=>{
    if (!sidebar.contains(event.target)) return;
    const button=event.target.closest('[data-plus-quantity-cart],[data-minus-quantity-cart],[data-cart-remove],#cart-sidebar-checkout');
    if(!button)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if(button.id==='cart-sidebar-checkout'){save(true);return;}
    const input=button.matches('[data-cart-remove]')?inputs().find(e=>e.dataset.line===button.dataset.line):button.parentElement.querySelector('[data-cart-quantity]');
    if(!input)return;
    input.value=button.matches('[data-cart-remove]')?0:Math.max(0,Number(input.value)+(button.hasAttribute('data-plus-quantity-cart')?1:-1));
    queue(input);
  },true);
})();
